// ============================================================================
// HEBREW TRANSLATIONS - CHAPTER 5: הקהילה הראשונה
// ============================================================================
// רמות 53-65 (13 רמות, 39 שאלות)

export const chapter5Translations = {
  name: "הקהילה הראשונה",
  description: "תקבלו כוח...",
  
  spiritualWisdom: {
    principle: "רוח הקודש נותן כוח ואומץ להעיד",
    scripture: "אֲבָל תְּקַבְּלוּ כֹּחַ כַּאֲשֶׁר רוּחַ הַקֹּדֶשׁ תָּבוֹא עֲלֵיכֶם, וִהְיִיתֶם לִי עֵדִים (מעשי השליחים 1:8)",
    application: "הקהילה נולדת באש הרוח וצומחת בעדות אמיצה"
  },
  
  levels: {
    53: {
      name: "העלייה לשמים",
      challenge: "תהיו לי עדים... עד קצה הארץ...",
      easy: {
        question: "כמה ימים אחרי תחייתו עלה ישוע לשמים?",
        options: ["30 יום", "40 יום", "50 יום", "60 יום"],
        hint: "המספר המקראי של הכנה",
        funFact: "☁️ 40 יום של הוראה אינטנסיבית לפני המשימה העולמית!"
      },
      medium: {
        question: "איזו הבטחה נותן ישוע לפני שהוא עולה לשמים?",
        options: [
          "הוא יחזור בקרוב",
          "הוא ישלח את רוח הקודש בכוח",
          "הוא יבנה קהילה",
          "הוא יענש את הרשעים"
        ],
        hint: "כוח מלמעלה",
        funFact: "⚡ הבטחת רוח הקודש - שינוי התלמידים הפחדנים!"
      },
      hard: {
        question: "מה מסמלת העלייה לשמים בחיינו הרוחניים?",
        options: [
          "סוף נוכחותו של ישוע",
          "ישוע מולך ומתפלל עבורנו בשמים",
          "הפרדה סופית",
          "מיתוס סמלי"
        ],
        hint: "מדובר בנוכחותו המהוללה והפעילה",
        funFact: "👑 ישוע מולך לימין אלוהים ומתפלל עבורנו!"
      }
    },
    
    54: {
      name: "חג השבועות",
      challenge: "כולם התמלאו ברוח הקודש והתחילו לדבר...",
      easy: {
        question: "כמה ימים אחרי העלייה לשמים התרחש חג השבועות?",
        options: ["7 ימים", "10 ימים", "14 ימים", "20 ימים"],
        hint: "כעשרה ימים",
        funFact: "🔟 10 ימי תפילה אינטנסיבית מכינים להשפעת הרוח!"
      },
      medium: {
        question: "באיזו צורה הופיעה רוח הקודש?",
        options: [
          "כמו רוח סוערת",
          "כמו לשונות אש",
          "כמו יונה",
          "כמו אור"
        ],
        hint: "להבות שנחו על כל תלמיד",
        funFact: "🔥 לשונות אש: הרוח נותן אומץ ומתנת לשונות!"
      },
      hard: {
        question: "מה מייצג חג השבועות לקהילה האוניברסלית?",
        options: [
          "אירוע היסטורי מבודד",
          "הלידה הרשמית של הקהילה המיסיונרית",
          "נס של סקרנות",
          "תחילת החגיגות"
        ],
        hint: "מדובר בתעודת הלידה של הקהילה",
        funFact: "🎂 חג השבועות = יום הולדת הקהילה, תחילת המשימה העולמית!"
      }
    },

    55: {
      name: "הדרשה הראשונה של פטרוס",
      challenge: "מה נעשה, אנשים אחים? שובו...",
      easy: {
        question: "כמה אנשים הוטבלו אחרי דרשת פטרוס?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "שלושת אלפים נפשות",
        funFact: "🌊 3000 טבילות ביום אחד - התעוררות רוחנית יוצאת דופן!"
      },
      medium: {
        question: "במה האשים פטרוס את ההמון?",
        options: [
          "בבורות",
          "בצליבת ישוע המשיח",
          "בחוסר אמונה",
          "בצביעות"
        ],
        hint: "הפשע העליון נגד בן האלוהים",
        funFact: "⚔️ פטרוס, שכפר בישוע, מכריז עכשיו על אלוהותו!"
      },
      hard: {
        question: "איך השינוי של פטרוס ממחיש את פעולת רוח הקודש?",
        options: [
          "הוא נעשה משכיל יותר",
          "מפחדן ולא יציב, הוא נעשה אמיץ ויציב באמונה",
          "הוא רכש כוחות",
          "האישיות שלו משתנה"
        ],
        hint: "מדובר בקידוש על ידי הרוח",
        funFact: "🗿 ה'קנה המתנדנד' הופך ל'אבן איתנה' - כוח משנה!"
      }
    },

    56: {
      name: "הקהילה הראשונה",
      challenge: "הם התמידו בתורת השליחים ובאחווה...",
      easy: {
        question: "איך חלקו המשיחיים הראשונים את רכושם?",
        options: [
          "כל אחד שמר את שלו",
          "הכל היה להם משותף",
          "רק העשירים נתנו",
          "על פי חובה חוקית"
        ],
        hint: "קהילת נכסים מרצון",
        funFact: "🤝 אהבת אחים כה עזה שהם חולקים הכל באופן ספונטני!"
      },
      medium: {
        question: "למה הקדישו המשיחיים הראשונים את זמנם?",
        options: [
          "רק לעסקים",
          "תורה, אחווה, שבירת לחם, תפילות",
          "רק לעבודה",
          "לפנאי"
        ],
        hint: "ארבעה עמודים של חיי קהילה",
        funFact: "⛪ תורה, אחווה, אוכריסטיה, תפילה - יסודות הקהילה!"
      },
      hard: {
        question: "למה הקהילה הראשונה הזו הייתה כל כך מושכת?",
        options: [
          "היא הייתה עשירה",
          "אהבה אמיתית ושמחה קרנו מאחדותם",
          "היא הבטיחה ניסים",
          "היא ביקרה אחרים"
        ],
        hint: "מדובר בעדות של אהבה חיה",
        funFact: "✨ 'ראו איך הם אוהבים זה את זה!' - עדות משכנעת יותר מהמילים!"
      }
    },

    57: {
      name: "ריפוי הפיסח",
      challenge: "כסף וזהב אין לי; אבל מה שיש לי אתן לך...",
      easy: {
        question: "מאז מתי האיש היה פיסח?",
        options: [
          "מזה 20 שנה",
          "מזה 30 שנה", 
          "מלידה",
          "מזה 10 שנים"
        ],
        hint: "מום מתמיד",
        funFact: "🚶 40 שנה של מום נרפאו מיד בשם ישוע!"
      },
      medium: {
        question: "בשם מי פטרוס ריפא את הפיסח?",
        options: [
          "בשם אלוהים",
          "בשם ישוע המשיח מנצרת",
          "בשמו שלו",
          "בשם אברהם"
        ],
        hint: "השם שמעל כל שם",
        funFact: "✊ שמו של ישוע ממשיך לפעול ניסים דרך השליחים!"
      },
      hard: {
        question: "מה מסמל הריפוי הזה לבשורה?",
        options: [
          "נס רפואי פשוט",
          "הישועה המוחלטת שישוע מביא: רוחנית ופיזית",
          "כוחם של השליחים",
          "צדקה לעניים"
        ],
        hint: "מדובר בישועה מוחלטת של האדם",
        funFact: "🩺 ישוע מרפא את הנשמה והגוף - ישועה שלמה של האדם!"
      }
    },

    58: {
      name: "הרדיפה מתחילה",
      challenge: "צריך לציית לאלוהים יותר מאשר לבני אדם...",
      easy: {
        question: "מי עצר את פטרוס ויוחנן אחרי ריפוי הפיסח?",
        options: [
          "הרומאים",
          "הצדוקים והכוהנים",
          "העם",
          "פילטוס"
        ],
        hint: "הרשויות הדתיות היהודיות",
        funFact: "⛓️ רדיפה דתית ראשונה - הבשורה מפריעה לממסד!"
      },
      medium: {
        question: "איזה איסור נתנו השלטונות לשליחים?",
        options: [
          "לעזוב את ירושלים",
          "לא ללמד עוד בשם ישוע",
          "לא לעשות עוד ניסים",
          "לא להתפלל עוד"
        ],
        hint: "איסור להטיף",
        funFact: "🚫 מנסים להשתיק את האמת - בלתי אפשרי לעצור את הבשורה!"
      },
      hard: {
        question: "איך הגיבו השליחים לאיסור?",
        options: [
          "הם ציותו מפחד",
          "הם אמרו שצריך לציית לאלוהים יותר מאשר לבני אדם",
          "הם ניהלו משא ומתן",
          "הם ברחו"
        ],
        hint: "מדובר בנאמנות גבוהה יותר מחוקים אנושיים",
        funFact: "⚖️ אי ציות אזרחי כדי לציית לאלוהים - אומץ של הרשעה!"
      }
    },

    59: {
      name: "חנניה וספירה",
      challenge: "לא לבני אדם שיקרת, אלא לאלוהים...",
      easy: {
        question: "איזה שקר אמרו חנניה וספירה?",
        options: [
          "הם לא מכרו כלום",
          "הם נתנו את כל מחיר המכירה כשהם שמרו חלק",
          "הם היו עניים",
          "הם לא היו נשואים"
        ],
        hint: "שקר על הסכום שניתן",
        funFact: "💰 לשמור חלק היה מותר, לשקר על המתנה לא!"
      },
      medium: {
        question: "מה קרה להם אחרי השקר שלהם?",
        options: [
          "הם נסלחו",
          "הם מתו פתאום",
          "הם הודרו",
          "הם שבו בתשובה"
        ],
        hint: "עונש מיידי וחמור",
        funFact: "⚱️ משפט חמור לשמור על טהרת הקהילה הצעירה!"
      },
      hard: {
        question: "למה עונש כה חמור בתחילת הקהילה?",
        options: [
          "אלוהים היה אכזרי",
          "כדי לבסס את הקדושה הנדרשת בקהילה",
          "כדי להפחיד",
          "במקרה"
        ],
        hint: "מדובר בשמירה על יושרה רוחנית",
        funFact: "🔥 סטנדרטים גבוהים בהתחלה כדי לבסס תרבות של קדושה!"
      }
    },

    60: {
      name: "שבעת השמשים",
      challenge: "בחרו מכם שבעה אנשים בעלי שם טוב...",
      easy: {
        question: "כמה שמשים נבחרו?",
        options: ["5", "6", "7", "12"],
        hint: "מספר השלמות",
        funFact: "7️⃣ שבעה שמשים לשירות - ארגון אלוהי של הקהילה!"
      },
      medium: {
        question: "מה היה תפקידם העיקרי?",
        options: [
          "להטיף את הבשורה",
          "לשרת על השולחנות ולעזור לאלמנות",
          "להטביל מומרים חדשים",
          "לנהל את הכספים"
        ],
        hint: "שירות חברתי וחומרי",
        funFact: "🍽️ שירות שולחנות = הארגון הצדקה הנוצרי הראשון!"
      },
      hard: {
        question: "מה מגלה הארגון הזה על החזון הנוצרי של שירות?",
        options: [
          "משימות חומריות נחותות",
          "שירות רוחני וחומרי שניהם קדושים",
          "צריך להפריד בין הקדוש לחול",
          "רק כוהנים משרתים באמת"
        ],
        hint: "מדובר בקדושת כל שירות של אהבה",
        funFact: "✨ לשרת על השולחנות באותה כבוד כמו להטיף - כל שירות קדוש!"
      }
    },

    61: {
      name: "סטפנוס, הקדוש הראשון",
      challenge: "אדוני, אל תחשוב להם את החטא הזה! ובאמרו זאת, נרדם...",
      easy: {
        question: "מה הייתה תפקידו של סטפנוס בקהילה?",
        options: ["שליח", "שמש", "כוהן", "נביא"],
        hint: "אחד משבעת הנבחרים לשרת",
        funFact: "✨ סטפנוס: שמש הפך למבשר עוצמתי וקדוש ראשון!"
      },
      medium: {
        question: "במה האשים סטפנוס את המנהיגים היהודיים?",
        options: [
          "בשחיתות",
          "בהתנגדות תמידית לרוח הקודש",
          "בצביעות",
          "בחמדנות"
        ],
        hint: "התנגדות היסטורית לאלוהים",
        funFact: "📜 סטפנוס מסכם את ההיסטוריה: מרד מתמיד נגד אלוהים!"
      },
      hard: {
        question: "איך מת סטפנוס ומה מגלה יחסו?",
        options: [
          "בכעס נגד הוריגיו",
          "בסליחה כמו ישוע על הצלב",
          "בייאוש",
          "בקללת אויביו"
        ],
        hint: "מדובר בחיקוי מושלם של המשיח",
        funFact: "💝 סליחה להוריגים: סטפנוס משחזר בצורה מושלמת את יחסו של ישוע!"
      }
    },

    62: {
      name: "פיליפוס והסריס האתיופי",
      challenge: "איך אוכל להבין אם מישהו לא ידריך אותי?",
      easy: {
        question: "מה קרא הסריס בכרכרה שלו?",
        options: [
          "תהילים",
          "ישעיהו הנביא",
          "בראשית",
          "משלי"
        ],
        hint: "הנביא של הצלב של המשיח",
        funFact: "📖 ישעיהו 53 - נבואה מושלמת על ישוע שנקראת על ידי מחפש כן!"
      },
      medium: {
        question: "איך הסביר פיליפוס את הקטע מישעיהו?",
        options: [
          "הוא דיבר על היסטוריה עתיקה",
          "הוא בישר את ישוע מתוך הטקסט הזה",
          "הוא נתן שיעור תיאולוגיה",
          "הוא ביקר פרשנויות"
        ],
        hint: "הכתובים מובילים באופן טבעי למשיח",
        funFact: "✝️ כל הכתובים מתכנסים לישוע - מפתח ההבנה!"
      },
      hard: {
        question: "מה מסמל המרתו של הסריס האתיופי?",
        options: [
          "המרה מבודדת",
          "האוניברסליות של הבשורה לכל הגזעים והמעמדות",
          "עליונות של עמים מסוימים",
          "מקרה מיוחד"
        ],
        hint: "מדובר בפתיחה לאומות",
        funFact: "🌍 אתיופי, סריס, שר: הבשורה שוברת את כל המחסומים!"
      }
    },

    63: {
      name: "המרתו של שאול מטרסוס",
      challenge: "שאול, שאול, למה אתה רודף אותי?",
      easy: {
        question: "מה עשה שאול לפני המרתו?",
        options: [
          "הוא הטיף את הבשורה",
          "הוא רדף את המשיחיים",
          "הוא היה ניטרלי",
          "הוא רק למד"
        ],
        hint: "אויב מושבע של התלמידים",
        funFact: "⚔️ שאול נשם איומים ורצח נגד תלמידי ישוע!"
      },
      medium: {
        question: "באיזה דרך ישוע הופיע לשאול?",
        options: [
          "הדרך לירושלים",
          "הדרך לדמשק",
          "הדרך לעזה",
          "הדרך לאנטיוכיה"
        ],
        hint: "עיר בסוריה",
        funFact: "🛤️ דרך דמשק = המקום המפורסם ביותר של שינוי בהיסטוריה!"
      },
      hard: {
        question: "איך ההמרה הזו ממחישה את החסד האלוהי?",
        options: [
          "אלוהים ממיר רק את הטובים",
          "החסד יכול להפוך את האויב הגרוע ביותר לשליח הגדול ביותר",
          "ההמרה הייתה ראויה",
          "שאול כבר היה קרוב לאלוהים"
        ],
        hint: "מדובר בכוח המשנה של החסד",
        funFact: "⚡ מהרודף הגדול ביותר למיסיונר הגדול ביותר - נס של חסד!"
      }
    },

    64: {
      name: "פטרוס וקורנליוס",
      challenge: "באמת אני מבין שאלוהים לא נושא פנים...",
      easy: {
        question: "מה היה המקצוע של קורנליוס?",
        options: [
          "סוחר",
          "מאות רומי",
          "כוהן",
          "סופר"
        ],
        hint: "קצין בצבא הרומי",
        funFact: "🎖️ הגוי הראשון שהומר רשמית - פתיחה ללא-יהודים!"
      },
      medium: {
        question: "איזה חזון ראה פטרוס לפני שפגש את קורנליוס?",
        options: [
          "מלאך שדיבר איתו",
          "סדין עם חיות טהורות וטמאות",
          "ישוע שהופיע לו",
          "מקדש הרוס"
        ],
        hint: "חזון על טהרה וטומאה",
        funFact: "🕊️ סדין עם חיות: אלוהים מבטל הבחנות תזונתיות וגזעיות!"
      },
      hard: {
        question: "איזה עיקרון מהפכני ביסס ההמרה הזו?",
        options: [
          "הרומאים עדיפים",
          "אלוהים לא נושא פנים - ישועה אוניברסלית",
          "צריך לנטוש מסורות",
          "המילה חסרת תועלת"
        ],
        hint: "מדובר באוניברסליות הישועה",
        funFact: "🌍 מהפכה רוחנית: הבשורה לכל העמים ללא יוצא מן הכלל!"
      }
    },

    65: {
      name: "הקהילה באנטיוכיה",
      challenge: "באנטיוכיה נקראו התלמידים נוצרים לראשונה...",
      easy: {
        question: "איך נקראו התלמידים לראשונה באנטיוכיה?",
        options: ["תלמידים", "נוצרים", "מאמינים", "קדושים"],
        hint: "השם שאנחנו נושאים עד היום",
        funFact: "✝️ 'נוצרים' = 'משיחים קטנים' - שם כבוד שניתן על ידי גויים!"
      },
      medium: {
        question: "מי בא ללמד באנטיוכיה עם ברנבא?",
        options: [
          "פטרוס",
          "פאולוס (שאול)",
          "יעקב",
          "יוחנן"
        ],
        hint: "הרודף לשעבר שהפך לשליח",
        funFact: "👥 ברנבא מחפש את פאולוס בטרסוס - תחילת השירות הפאוליני!"
      },
      hard: {
        question: "למה אנטיוכיה הפכה לכל כך חשובה בהיסטוריה הנוצרית?",
        options: [
          "היא הייתה עשירה",
          "המרכז המיסיונרי הראשון לגויים",
          "היא הייתה ממוקמת טוב",
          "היו לה מנהיגים טובים"
        ],
        hint: "מדובר בהתרחבות מיסיונרית",
        funFact: "🚢 אנטיוכיה: נמל השיגור של כל משלחות פאולוס לאירופה!"
      }
    }
  }
};

export default chapter5Translations;
